import React, { useState } from "react"
import ListItem from "jd-library/ListItem"
import Button from "jd-library/Button"
import SliderWrapper from "jd-library/SliderWrapper"
import MoreMenu from "jd-library/MoreMenu"
import style from "./list-deliveryboy.scss"
import withRipple from "jd-library/withRipple"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import { deleteDeliveryBoy } from "../utils"
import { useDispatch } from "react-redux"
import { getDeliveryBoyList } from "../../../actions/deliveryBoy"
import toastMessageActions from "jd-library/toastMessageActions"

const opration = ["Add", "Edit", "Delete"]

const RippleDiv = withRipple(
  ({
    className = "",
    rippleClass,
    rippleHandler,
    renderRipple,
    children,
    as: Component = "div",
    ...props
  }) => {
    return (
      <Component
        className={`${rippleClass} ${className}`}
        {...props}
        {...rippleHandler}
      >
        {children}
        {renderRipple()}
      </Component>
    )
  }
)

const ListDeliveryBoy = (props) => {
  const dispatch = useDispatch()
  const token = props.session.token
  const [show, toggleSlider] = useState(false)
  const data = useSelector((state) => state.deliveryBoy.deliveryBoyList)
  const [crud, setCrud] = useState(opration)

  const edit = () => {}
  const del = () => {}

  const moreOpt = (e) => {
    console.log(e)
    alert("I M Clicked")
    e.preventDefault()
  }

  const leftIcons = [
    {
      className: "icon-key-left",
      onClick: () => {
        props.apkback ? props.apkback() : historyHandler.closeCurrent()
      },
    },
  ]

  const rightIcons = [
    {
      className: "icon-HDRcross",
      onClick: () => {
        props.apkback ? props.apkback() : historyHandler.closeCurrent()
      },
    },
  ]

  let buttonContent = (
    <>
      <span>
        <i className="icon-plus"></i>
      </span>
      <span className={style["text-format"]}>Add Delivery Boy</span>
    </>
  )

  let staffListing = data.map((staff, $index) => {
    let staffImage = ""
    if (staff.image_url && (staff.image_url.indexOf('https://') > -1 || staff.image_url.indexOf('http://') > -1)) {
      staffImage = <img className={style["staff-img"]} src={staff.image_url} />
    } else {
      let inital = staff.name.toUpperCase()
      inital = inital[0]
      staffImage = <i className={"icon-logo" + inital} />
    }
    return (
      <div>
        <div onClick={()=> props.showAddDeliveryBoy("2", "1", staff)} className={style["staff-list-detail"]}>
          <RippleDiv className={style["ripple-container"]}>
            <div className={style["staff-container"]}>
              <div className={style["staff-image-container"]}>{staffImage}</div>
              <div>
                <div className={style["name"]}>{staff.name}</div>
                <div className={style["mobile"]}>
                  {"+91"} {staff.mobile}
                </div>
              </div>
            </div>
          </RippleDiv>
          <div className={style["more-options"]}>
            <MoreMenu
              list={[
                {
                  label: "Edit",
                  onClick: () => {
                    //moreOptionsAction("edit", $index)
                    props.showAddDeliveryBoy("2", "1", staff)
                  },
                },
                {
                  label: "Delete",
                  onClick: async () => {
                    const res = await deleteDeliveryBoy({
                      token,
                      mobile: staff.mobile,
										} )
										dispatch(
                      toastMessageActions.showMessage({
                        message:
                          res?.data?.errors?.msg ||
                          res?.data?.results?.msg ||
													"",
												type:'info',
                      })
                    )
                    getDeliveryBoyList(dispatch, props.session.token)
                  },
                },
              ]}
              slideFrom="rightTop"
            />
          </div>
        </div>
      </div>
    )
  })

  return (
    <>
      <SliderWrapper
        avoidPortal
        header={{
          className: style["header"],
          leftIcons: props.isMobile ? leftIcons : [],
          heading: `Delivery Boys`,
          rightIcons: !props.isMobile ? rightIcons : [],
        }}
        slider={{
          className: style["staff-listing"],
        }}
        footer={{
          btnProps: [
            {
              children: buttonContent,
              variant: "default",
              onClick: () => {
                props.showAddDeliveryBoy("2", "1")
              },
              className: style["add-staff-button"],
              size: "xl",
              raised: true,
            },
          ],
        }}
        onHidden={() => {
          //window.history.back()
          historyHandler.closeCurrent()
          props.apkback ? props.apkback() : window.history.back()
        }}
      >
        <div>
          {staffListing && (
            <div className={style["staff-list-container"]}>{staffListing}</div>
          )}
          {!data && <div>...Loading</div>}
        </div>
      </SliderWrapper>
      {/*<div style={{backgroundImage: 'url("https://image1.jdomni.in/jdomni_email/Jdbusinessbg_2207071808.png")',
      marginLeft: "80px", height: "500px", backgroundRepeat: "no-repeat"}}>
        </div>*/}
    </>
  )
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    isMobile: state.library.deviceData.isMobile,
    session: state.session,
  }
}
export default connect(mapStateToProps, {})(ListDeliveryBoy)
